// extracted by mini-css-extract-plugin
export var label = "_ci-1";
export var reminder = "_ci-0";